import { httpClient } from '@/services/http/httpClient'

export type UpdateWorkflowParams = {
  id: string
  workflowId: string
}

// TO - DO - Create test
export async function insertWorkflowInIdea({
  id,
  workflowId,
}: UpdateWorkflowParams) {
  await httpClient.put(`/ideas/funnel/ideas/${id}/workflow`, {
    processActivityId: workflowId,
  })
}
